import {Header, SpinningLoader} from '@/components';

import {DocumentList} from '../DocumentList';
import KYBSummary from './KYBSummary';
import useMerchantKYB from './useMerchantKYB';

export default function MerchantKYBScreen() {
  const {
    loading,
    loadingKYB,
    businessDetails,
    updateBusinessKYB,
    requestAdditionalDocuments,
    updateBusinessFlag,
    updateBusinessPostFundingConfig,
    isPostFundingConfigSubmitting,
    businessLoadingFlags,
    fileUrls,
  } = useMerchantKYB();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <SpinningLoader />
      </div>
    );
  }
  return (
    <main className="px-3 pt-3 my-8">
      <Header
        dataCy="merchant-business-kyb-details-title"
        title="Business KYB Details"
      />
      <KYBSummary
        business={businessDetails}
        onSubmit={updateBusinessKYB}
        onRequestAdditionalDocuments={requestAdditionalDocuments}
        isKycSubmitting={loadingKYB}
        onFlagUpdate={updateBusinessFlag}
        businessLoadingFlags={businessLoadingFlags}
        onPostFundingConfigUpdate={updateBusinessPostFundingConfig}
        isPostFundingConfigSubmitting={isPostFundingConfigSubmitting}
      />
      <DocumentList title="Uploaded Business Document(s)" items={fileUrls} />
    </main>
  );
}
